<label>{{ label }}</label>
<ng-content></ng-content>
